import React, { Component } from 'react';
import './Callback.css';
import CallbackForm from "../CallbackForm/CallbackForm";
import { Link } from 'react-router';

const STATES = {
    CLOSED: 0,
    CLOSING: 1,
    OPEN: 2,
    OPENING: 3,
}

class Callback extends Component {

    constructor(props) {
        super(props);
        this.state = {
            status: Callback.STATES.CLOSED,
            preview: true,
            url: props.url,
            site: props.url
        };

    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({preview: false});
        },10000);
    }

    static propTypes =  {
        onChange:   React.PropTypes.func
    }

    handleClick = (e) =>  {
        if (typeof this.props.onChange === 'function') {
            //this.props.onChange();
        }
    }

    toggle (e) {
        if (typeof this.props.onChange === 'function') {
            //this.props.onChange();
        }

        //7console.log("Callback - toggle: ", this.state.status);
        if (this.state.status === Callback.STATES.OPEN) {
            this.close();
        } else {
            this.open();
        }
    }

    open () {
        this.setState({status: Callback.STATES.OPEN});
    }

    close () {
        this.setState({status: Callback.STATES.CLOSED});
    }

    onSend () {
        setTimeout(() => {
            this.close();
        }, 5000);
    }

  render() {
    const classNames = ["Callback"];

    const open = this.state.status === Callback.STATES.OPEN;
    const closed = this.state.status === Callback.STATES.CLOSED;

    if (open) {
        classNames.push("in");
    } else if (closed) {
        classNames.push("out");
    }

    let buttonClasses = ["Button", "BtnOpener"];
    if (this.state.preview) {
        buttonClasses.push("Preview")
    }

    return (
            <div className={classNames.join(" ")}>
                <button className={buttonClasses.join(" ")} onClick={(e) => this.toggle(e)}>
                    {!open && <span>Möchten Sie zurück- gerufen werden? </span>}
                    {open && <span>Hinterlassen Sie Namen und Telefon- nummer und wir rufen Sie gerne zurück.</span>}
                    <i className="Icon material-icons">contact_phone</i>
                </button>
                <div className={"Callback-Wrapper"}>
                    <div className="Callback-Content">
                        <button className="Button BtnClose" onClick={(e) => this.toggle(e)}>
                            <i className="Icon material-icons">close</i>
                        </button>
                        <CallbackForm closed={closed} url={this.props.url} site={this.props.site} onSend={() => this.onSend()}/>
                        <p>Bitte beachten Sie unsere Hinweise zum <Link to="/sonstiges/datenschutz">Datenschutz</Link></p>
                    </div>
                </div>
            </div>
    );
  }
}

Callback.STATES = STATES;
export default Callback;



// WEBPACK FOOTER //
// ./src/components/Callback/Callback.js